import { render, staticRenderFns } from "./tag-management.component.vue?vue&type=template&id=57650263&scoped=true"
import script from "./tag-management.component.ts?vue&type=script&lang=ts&external"
export * from "./tag-management.component.ts?vue&type=script&lang=ts&external"
import style0 from "./tag-management.component.vue?vue&type=style&index=0&id=57650263&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57650263",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57650263')) {
      api.createRecord('57650263', component.options)
    } else {
      api.reload('57650263', component.options)
    }
    module.hot.accept("./tag-management.component.vue?vue&type=template&id=57650263&scoped=true", function () {
      api.rerender('57650263', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client/site-setup/site-setup-location-form/tag-management/tag-management.component.vue"
export default component.exports